<template>
  <div class="py-2" style="width: 100%;">
    <div class="year-month-box d-flex justify-space-between align-center mb-2">
      <div>
        {{ $moment(yearMonth + "-01").format("MMMM YYYY") }}
      </div>
      <div>
        <v-btn icon @click="changeMonth(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon @click="changeMonth(1)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="week-box">
      <div v-for="item in weekDays" class="day-box">
        {{ item }}
      </div>
    </div>
    <div class="week-box" v-if="range">
      <div v-for="data in dataDate" 
        :class="`day-box 
          ${ !data.isMonth ? 'not-month' : '' } 
          ${ (data.isPrevious && isDisablePrevious) || (data.isNow && isDisableNow)
            ? 'disabled' : '' 
          } 
          ${ rangeActive(data.date) ? 'active' : '' } 
          ${ $moment(data.date).isBetween(startDate, endDate) ? 'between' : '' } 
          ${ getEvent(data.date) ? getEvent(data.date).color : '' } 
          ${ color ? 'b-' + color : '' } 
        `">
        {{ data.text }}
      </div>
    </div>
    <div class="week-box" v-else-if="available">
      <div v-for="data in dataDate" 
        :class="`day-box 
          ${ !data.isMonth ? 'not-month' : '' } 
          ${ (data.isPrevious && isDisablePrevious) || (data.isNow && isDisableNow)
            ? 'disabled' : '' 
          } 
          ${ rangeActive(data.date) ? 'active' : '' } 
          ${ $moment(data.date).isBetween(startDate, endDate) && getEvent(data.date) ? 'between' : '' } 
          ${ getEvent(data.date) ? getEvent(data.date).color : '' } 
          ${ color ? 'b-' + color : '' } 
        `">
        {{ data.text }}
      </div>
    </div>
    <div class="week-box" v-else>
      <div v-for="data in dataDate" 
        @click="selectDate(data)"
        :class="`day-box select-mode
          ${ !data.isMonth ? 'not-month' : '' } 
          ${ (data.isPrevious && isDisablePrevious) || (data.isNow && isDisableNow)
            ? 'disabled' : '' 
          } 
          ${ value.indexOf(data.date) > -1 ? 'active' : '' } 
          ${ getEvent(data.date) ? getEvent(data.date).color : '' }
          ${ color ? 'b-' + color : '' } 
        `">
        {{ data.text }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    startDate: String,
    endDate: String,
    multiple: Boolean,
    range: Boolean,
    isDisablePrevious: {
      type: Boolean,
      default: false
    },
    isDisableNow: {
      type: Boolean,
      default: false
    },
    color: String,
    events: Array,
    available: Boolean,
    disabled: Boolean
  },
  // emits: ["update:value"],
  data() {
    return {
      weekDays: this.$moment.weekdays(),
      yearMonth: this.$moment().format("YYYY-MM"),
      dataDate: [],
    }
  },
  watch: {
    startDate() {
      this.yearMonth = this.$moment(this.startDate).format("YYYY-MM");
      this.initData()
    },
    endDate() {
      this.yearMonth = this.$moment(this.endDate).format("YYYY-MM");
      this.initData()
    }
  },
  computed: {

  },
  created() {
    this.initData()
  },
  methods: {
    rangeActive(date) {
      if(this.$moment(this.endDate) >= this.$moment(this.startDate) && (date == this.startDate || date == this.endDate)) {
        return true
      } else {
        return false
      }
    },
    initData(_yearMonth){
      let daysInMonth = this.$moment(this.yearMonth + "-01").daysInMonth()
      let mm = this.$moment(this.yearMonth + "-01");
      this.dataDate = []

      // before month
      while(mm.day() != 0) {
        mm.subtract(1, 'days')
        let now = this.$moment().startOf('day')
        this.dataDate.unshift({
          isPrevious: mm.isBefore(now),
          isNow: mm.isSame(now),
          text: mm.date(),
          date: mm.format("YYYY-MM-DD"),
        })
      }

      // current month
      mm = this.$moment(this.yearMonth + "-01").subtract(1, 'days');
      for(let i = 0; i < daysInMonth; i++) {
        mm.add(1, 'days')
        let now = this.$moment().startOf('day')
        this.dataDate.push({
          isMonth: true,
          isPrevious: mm.isBefore(now),
          isNow: mm.isSame(now),
          text: mm.date(),
          date: mm.format("YYYY-MM-DD"),
        })
      }

      // next month
      while(mm.day() != 6) {
        mm.add(1, 'days')
        let now = this.$moment().startOf('day')
        this.dataDate.push({
          isPrevious: mm.isBefore(now),
          isNow: mm.isSame(now),
          text: mm.date(),
          date: mm.format("YYYY-MM-DD"),
        })
      }
    },
    changeMonth(val) {
      this.yearMonth = this.$moment(this.yearMonth).add(val, 'months').format("YYYY-MM");
      this.initData()
    },
    selectDate(data){
      if(this.disabled) return false
      if(this.multiple) {
        if(this.value.indexOf(data.date) > -1) {
          let temp = this.value.filter(d => d != data.date)
          this.$emit("input", 
            temp.sort((a, b) => {
              return new Date(a) - new Date(b)
            })
          )
        }else{
          this.$emit("input", 
            [...this.value, data.date].sort((a, b) => {
              return new Date(a) - new Date(b)
            })
          )
        }
      }
      this.$emit("onClick", data)
    },
    getEvent(date) {
      if(this.events && this.events.length) {
        return this.events.find(e => e.date == date)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.year-month-box{
  color: black;
  font-weight: bold;
  font-size: 16px;
}
.week-box {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  width: 100%;
  text-align: center;
  // justify-content: center;
}
.day-box {
  width: 14.2%;
  text-align: center;
  font-size: 12px;
  aspect-ratio : 5 / 4;
  max-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  border-radius: 5px;

  &.active {
    background-color: var(--v-primary-base);
    color: white;
    &.success {
      background-color: var(--v-success-base) !important;
    }
    &.info {
      background-color: var(--v-info-base) !important;
    }
    &.error {
      background-color: var(--v-error-base) !important;
    }
    &.warning {
      background-color: var(--v-warning-base) !important;
    }
  }
  &.between {
    border-radius: 0px;
    color: var(--v-primary-base);
    background-color: var(--v-bgPrimary-base);
    &.success {
      color: var(--v-success-base);
      background-color: var(--v-bgSuccess-base) !important;
    }
    &.info {
      color: var(--v-info-base);
      background-color: var(--v-bgInfo-base) !important;
    }
    &.error {
      color: var(--v-error-base);
      background-color: var(--v-bgError-base) !important;
    }
    &.warning {
      color: var(--v-warning-base);
      background-color: var(--v-bgWarning-base) !important;
    }
  }
  .b-success {
    &.active {
      color: var(--v-success-base);
      background-color: var(--v-bgSuccess-base) !important;
    }
    &.between {
      color: var(--v-success-base);
      background-color: var(--v-bgSuccess-base) !important;
    }
  }
  &.disabled {
    opacity: .3;
    cursor: default;
    pointer-events: none;
  }
  &.not-month {
    opacity: .3;
  }
  &.select-mode{
    cursor: pointer;
    border: 1px solid white;
  }
}
</style>